import React, { useEffect } from "react";
import ReviewAns from "../_components/UI/ReviewAns";
import Header from "../_components/common/Header";


const Review = () => {
  

 
  return (
    <div className='page-main'>
      <Header
        name={["Upload Answer Sheets", "Student list", "Review Answers"]}
      />
      <ReviewAns />
    </div>
  );
};

export default Review;
